import { render } from "./FavoriteHeart.vue?vue&type=template&id=3d160d0d"
import script from "./FavoriteHeart.vue?vue&type=script&lang=js"
export * from "./FavoriteHeart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__